document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1.2, // Adjust based on design
    spaceBetween: 0,
    loop: true, // Enable looping
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true, // Allow manual scrolling
    },
  });
});
